'use client'

import { useEffect, useState } from 'react'
import { Project } from '@models/Project'

import { useAppStore } from '@/entities/app-store'

export function useProjectFromStore() {
  const appStore = useAppStore()
  const [project, setProject] = useState<Project | null>(null)

  const storeProject = appStore?.project
  const storeFirstProjectId = appStore?.getFirstProjectId()

  useEffect(() => {
    setProject(storeProject)
  }, [storeProject, storeFirstProjectId])

  return project
}
